export default __webpack_public_path__ + "static/media/guide_dev_05.55adf71b.md";